<template>
  <a-modal v-model="recordShow" title="录面访" @ok="handleInterview">
    <a-form-model-item label="面访时间">
      <a-date-picker
        show-time
        type="date"
        placeholder="请选择面访时间"
        format="YYYY-MM-DD"
        v-model="interviewRecorddate.interviewTime"
        style="width: 100%"
      />
    </a-form-model-item>
    <a-textarea
      class="interview-textarea"
      placeholder="请输入面访内容"
      v-model="interviewRecorddate.interviewContent"
      style="width: 100%"
    />
    <!--    <h4>面访附件</h4>-->
    <!--    <div>-->
    <!--      <UploadBtn @input="uploadInterviewUrl" @ossId="interviewOssid" />-->
    <!--    </div>-->
  </a-modal>
</template>
<script>
import houseApi from '@/api/system/houses/house.js'
import UploadBtn from '@/components/UploadBtn'

export default {
    data () {
        return {
           recordShow: false,
            // 录面访 数据
            interviewRecorddate: {
                accessoryIds: '', // 附件id
                interviewContent: '',
                interviewTime: '',
                resourceId: 0,
                resourceType: 1
            },
            interviewUrl: '' // 面访url
        }
    },
    components: {
        UploadBtn
    },

    props: {
        houseId: {
            type: String,
            require: true
        },
        rentSaleType: {
            type: String,
            default: '1',
            require: true
        }
    },
    methods: {
        // 录面访图片
    uploadInterviewUrl (e) {
        this.interviewUrl = e
    },
    interviewOssid (id) {
        this.interviewRecorddate.accessoryIds = id
    },
    cancel () {
      console.log('关闭面访')
    },
            // 录制面访提交
    handleInterview () {
      if (!this.interviewRecorddate.interviewTime) {
        this.$message.warning('请输入面访时间')
        return
      }
      if (!this.interviewRecorddate.interviewContent) {
        this.$message.warning('请输入面访内容')
        return
      }
      // if (!this.interviewRecorddate.accessoryIds) {
      //   this.$message.warning('请上传面访附件')
      //   return
      // }
      const sdate = new Date(this.interviewRecorddate.interviewTime)
      const aa = sdate.getFullYear() + '-' + (sdate.getMonth() + 1) + '-' + sdate.getDate()
      this.interviewRecorddate.interviewTime = aa
      this.interviewRecorddate.resourceId = this.houseId
      this.interviewRecorddate.rentSaleType = this.rentSaleType
      houseApi.interviewRecord({ ...this.interviewRecorddate }).then((res) => {
        if (res.code === 200) {
          this.$message.success('录入面访成功')
          this.$emit('upStatus', 0)
          this.recordShow = false
        }
      })
    }

    }
}
</script>
<style lang="less" scoped>
.interview-textarea {
  margin-top: 20px;
  width: 100%;
  height: 90px;
  outline: none;
  border-radius: 10px;
  border-color: #f1f2f3;
  padding: 10px;
  margin-bottom: 20px;
  resize: none;
  overflow: hidden;
}
</style>
